import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useCurrentUser, userIsBuero } from "@/lib/auth";

/** Leitet Büro-Nutzer von Standalone-Pfaden in die Dokumente-Sektion um. */
export function BueroDokumenteRedirect({
  to,
  children,
}: {
  to: string;
  children: ReactNode;
}) {
  const { user, loading } = useCurrentUser();
  if (loading) return null;
  if (userIsBuero(user)) {
    return <Navigate to={to} replace />;
  }
  return <>{children}</>;
}
